import * as React from 'react';
import { Trans } from 'react-i18next';
import s from '../Cycles/Cycles.scss';
import classNames from 'classnames';
import {
  PremiumCurrencyFormatter,
  CurrencyAndFormatToString,
} from '@wix/premium-react-text';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import { PaymentCycle } from 'enums';
import { Text } from '@wix/design-system';

export interface DiscountBadgeProps extends InjectedExperimentsProps {
  isCycleSelected: boolean;
  discount: number;
  cycleId: PaymentCycle;
  logBi(): void;
}

export const DiscountBadgeComp: React.FunctionComponent<DiscountBadgeProps> = ({
  isCycleSelected,
  discount,
}) => {
  return (
    <PremiumCurrencyFormatter
      currencySettingsOverride={{ fractionSize: 0 }}
      render={(formatCurrency) => (
        <DiscountBadgeContent
          formatCurrency={formatCurrency}
          isCycleSelected={isCycleSelected}
          discount={discount}
        />
      )}
    />
  );
};

const DiscountBadgeContent: React.FC<{
  formatCurrency: CurrencyAndFormatToString;
  isCycleSelected: boolean;
  discount: number;
}> = ({ discount, isCycleSelected, formatCurrency }) => {
  const discountBadgeClassNames = classNames(s.discountBadge, s.green, {
    [s.cycleSelected]: isCycleSelected,
  });
  return (
    <div className={discountBadgeClassNames}>
      <Text
        size='small'
        weight='bold'
        className={s.badgeText}
        light={isCycleSelected}
        skin={isCycleSelected ? 'standard' : 'success'}
        dataHook='discount-badge'
      >
        <Trans
          i18nKey='cycle_entry.cycle_discount'
          values={{ discount: formatCurrency(discount) }}
        >
          part1 <span> part2</span>
        </Trans>
      </Text>
    </div>
  );
};

export const DiscountBadge = withExperiments(DiscountBadgeComp);
